<div class="main-container">
  <button
    type="button"
    class="btn primary-btn"
    (click)="openNewBasketModal()"
  >
    {{ "basket.new_basket" | translate }}
  </button>
  <div ngbAccordion class="mt-2">
    <div ngbAccordionItem *ngFor="let basket of allBaskets">
      <div
        ngbAccordionHeader
        class="accordion-button custom-header align-items-center"
      >
        <div
          *ngIf="basket.id !== editedBasket.id"
          class="basket-name"
          (dblclick)="onStartEditing(basket)"
        >
          {{ basket.name }}
        </div>
        <input
          *ngIf="basket.id === editedBasket.id"
          type="text"
          appPrefixFocusAndSelect
          class="form-control edit-basket-input ms-4 me-1"
          maxlength="30"
          [(ngModel)]="editedBasket.name"
          (keydown.enter)="onSaveEditing()"
          (keydown.escape)="onCancelEditing()"
          (click)="$event.stopPropagation()"
        />
        <fa-icon
          class="delete-basket-icon remove-icon ms-4"
          (click)="onDeleteBasket(basket.id!)"
          [icon]="['fas', 'trash']"
        ></fa-icon>
        <button
          ngbAccordionToggle
          class="accordion-button open-button ms-auto"
        ></button>
      </div>
      <div ngbAccordionCollapse>
        <div ngbAccordionBody>
          <app-table-basket-employee
            [basketId]="basket.id"
            [profiles]="basket.profiles!"
            [profileExportQueue]="profileExportQueue"
            (profileRemoved)="onProfileRemovedFromBasket($event)"
            (profileUpdatedInBasket)="onProfileUpdated($event)"
            class="table-basket-employee"
          ></app-table-basket-employee>
        </div>
      </div>
    </div>
  </div>
</div>
